// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__DTUSm","subheader":"ReorderModal_subheader__1WJRf","listWrap":"ReorderModal_listWrap__3VHSb"};